import { gatewaySectorWorkFlows } from "../../../../../gateways/gatewaySectorWorkFlows";
import { IServiceListResponse } from "../interfaces/PaginationServicesResponse";

export const fetchQuoteAllServices = async (): Promise<IServiceListResponse> => {
  const token = sessionStorage.getItem("token");

  const res = await gatewaySectorWorkFlows.get("/type-of-service/", {
    headers: { Authorization: token },
    params: {
      page: 1,
      pageSize: 9999,
    }
  });

  const payload = res.data?.items ? res.data : res.data?.data;

  return payload as IServiceListResponse;
};
